module.exports = "/images/vendor/leaflet-search/search-icon.png?549b33bab7247b619c0292995f5a906b";